import { SIMULATION_ID_SEARCH_PARAM } from '../../../pages/Simulation/SimulationLandingPage';
import { SimulationWorkflowCard } from '../shared/SimulationWorkflowCard';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { Form, Switch, Space, Select, Tooltip, InputNumber } from 'antd';
import { useStoreActions, useStoreState } from '../../../store';
import { useEffect } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
const { Option } = Select;
export const ADD_MARGIN_SURCHARGE_MODIFIER_STEP_KEY = 'addMarginSurchargeModifierKey';

export const AddMarginSurchargeModifier = () => {
  const [query] = useSearchParams();
  const simulationId = query.get(SIMULATION_ID_SEARCH_PARAM);
  const [form] = Form.useForm();
  const applyCarrierSurcharges = Form.useWatch('applyCarrierSurcharges', form);
  const modifierType = Form.useWatch('modifierType', form);
  const percentBased = ['percentageDiscount', 'percentageIncrease'].includes(modifierType);
  const updateSimulation = useStoreActions((actions) => actions.simulation.updateSimulation);
  const simulationSetupData = useStoreState((state) => state.simulation.simulationSetupData);
  const setActiveNavigationStep = useStoreActions((actions) => actions.simulation.setActiveNavigationStep);
  const activeNavigationStep = useStoreState((state) => state.simulation.activeNavigationStep);
  const setSimulationSetupData = useStoreActions((actions) => actions.simulation.setSimulationSetupData);

  const handleNext = async () => {
    try {
      const vals = await form.validateFields();
      if (simulationId) {
        const modifiedSetupData = {
          ...simulationSetupData,
          [ADD_MARGIN_SURCHARGE_MODIFIER_STEP_KEY]: vals.applyCarrierSurcharges
            ? vals
            : { applyCarrierSurcharges: false },
        };
        await updateSimulation({
          simulationId,
          simulationSetupData: modifiedSetupData,
        });
        setSimulationSetupData(modifiedSetupData);
        setActiveNavigationStep(activeNavigationStep + 1);
      }
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    if (simulationSetupData[ADD_MARGIN_SURCHARGE_MODIFIER_STEP_KEY]) {
      form.setFieldsValue(simulationSetupData[ADD_MARGIN_SURCHARGE_MODIFIER_STEP_KEY]);
    }
  }, [form, simulationSetupData]);

  return (
    <SimulationWorkflowCard title="Modify Carrier Surcharges" simulationId={simulationId} onSave={handleNext}>
      <h3>
        <Tooltip title={'When enabled, selected simulation carrier surcharges will be added to your sell rates'}>
          <QuestionCircleOutlined />
        </Tooltip>
        {' Optionally apply modified carrier surcharges to your sell rates'}
      </h3>
      <Form form={form}>
        <Form.Item valuePropName="checked" name="applyCarrierSurcharges" label="Apply Surcharges">
          <Switch
            checkedChildren="Apply Carrier Surcharges to sell rates"
            unCheckedChildren="Do not apply carrier surcharges to sell rates"
          />
        </Form.Item>
        {applyCarrierSurcharges && (
          <Form.Item name={'surcharges'} label="Modify Surcharges">
            <Space>
              <Form.Item name={'amount'} noStyle>
                <InputNumber prefix={percentBased ? '%' : '$'} />
              </Form.Item>
              <Form.Item initialValue={'percentageDiscount'} name={'modifierType'} noStyle>
                <Select style={{ minWidth: 200 }}>
                  <Option value="percentageDiscount">Percentage Discount</Option>
                  <Option value="percentageIncrease">Percentage Cost Increase</Option>
                  <Option value="flatDiscount">Flat Discount</Option>
                  <Option value="flatIncrease">Flat Increase</Option>
                </Select>
              </Form.Item>
            </Space>
          </Form.Item>
        )}
      </Form>
    </SimulationWorkflowCard>
  );
};
